<template>
    <div>
        <div class="expiry-data d-flex justify-content-between align-items-center flex-wrap mb-3">
            <h2 class="text-left mb-0">{{ activeTab === 'schedule' ? $t('scheduleAndRecurring.schedule') : $t('scheduleAndRecurring.recurring') }}</h2>
            <div class="d-flex justify-content-between justify-content-sm-center flex-wrap">
                <b-button @click="showMaintenaceModal()" v-if="allowAddData && activeTab === 'recurringSchedule'"
                    class="export equipment d-flex justify-content-center align-items-center mx-1 my-1 w-fit-content"
                    variant="primary">
                    <b-icon icon="plus" aria-hidden="true"></b-icon>
                    <p class="mb-0 ml-2 text-white">{{ $t('scheduleAndRecurring.addRecurring') }}</p>
                </b-button>
                <b-dropdown id="dropdown-divider" text="text" class="load-dropdown-2"
                    v-if="activeTab !== 'recurringSchedule' && allowExportData">
                    <template slot="button-content">
                        <b-icon class="dots" icon="three-dots"></b-icon>
                    </template>
                    <b-dropdown-item-button v-if="allowExportData" @click="downloadExcel">
                        <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('scheduleAndRecurring.exportCsv') }}</p>
                    </b-dropdown-item-button>
                </b-dropdown>
            </div>
        </div>
        <div class="data-table team-data-table bg-white rounded table-custom-border">
            <div class="bg-white rounded">
                <v-tabs class="team-tabs mb-0" show-arrows>
                    <v-tab @click="activeTab = 'schedule'">{{ $t('scheduleAndRecurring.schedule') }}</v-tab>
                    <v-tab @click="activeTab = 'recurringSchedule'">{{ $t('scheduleAndRecurring.recurring') }}</v-tab>
                </v-tabs>
            </div>
            <div class="bg-white pt-3 pt-sm-4 rounded">
                <div class="table_row">
                    <Schedule v-if="activeTab === 'schedule'" ref="scheduleSection" />
                    <RecurringSchedule v-if="activeTab === 'recurringSchedule'"
                        :allowAddRecurringSchedule="allowAddRecurringSchedule" @close="allowAddRecurringSchedule = false" />
                </div>
            </div>
        </div>
        <DeleteModal v-if="showModal" @confirm="deleteItem($event)" />
    </div>
</template>
  
<script>
import { mapActions, mapGetters } from "vuex";

import DeleteModal from "@/components/DeleteModal.vue";
import Schedule from "@/components/Maintenance/Schedule.vue";
import RecurringSchedule from "@/components/Maintenance/RecurringSchedule.vue";

export default {
    name: "RecordsAndTotal",
    components: {
        DeleteModal,
        Schedule,
        RecurringSchedule
    },
    data() {
        return {
            activeTab: "schedule",
            maintenanceSchedulePopup: false,
            allowAddRecurringSchedule: false,
            itemId: 0,
            showModal: false,
            deleteScheduleItem: false,
        };
    },
    computed: {
        ...mapGetters(["maintenance", "allEquipments", "maintenanceSchedule", "rolePermissions"]),
        allowAddData() {
            return this.rolePermissions && this.rolePermissions['Maintenance'] && this.rolePermissions['Maintenance'][2].allow
        },
        allowExportData() {
            return this.rolePermissions && this.rolePermissions['Maintenance'] && this.rolePermissions['Maintenance'][5].allow
        }
    },
    methods: {
        ...mapActions([
            "getMaintenance",
            "setNotification",
            "deleteMaintenance",
            "getMaintenanceSchedule",
            "deleteMaintenance",
            "deleteMaintenanceSchedule",
            "setLoader"
        ]),
        async downloadExcel() {
            await this.$refs.scheduleSection.downloadExcel()
        },
        showMaintenaceModal() {
            this.allowAddRecurringSchedule = true
        },
        deleteItem(item) {
            if (item) {
                this.deleteSchedule(this.itemId);
            }
            this.showModal = false;
            this.deleteScheduleItem = false;
        },
    },
};
</script>
  
  